<template>
  <div>
    <div class="error">
      {{ message }}
    </div>
    <br>
    <div class="form-group" style="text-transform:capitalize">
      <router-link :to="{name:'Terms'}" target="_blank">
        {{ $t('login.terms')}}
      </router-link>
    </div>
  </div>
</template>


<script>
export default {
  props: ['message']
}
</script>

<style lang="stylus" scoped>
.error
  border solid 1px white
  padding 1em
  border-radius 0.5em
  background-color red
  color white
</style>



// WEBPACK FOOTER //
// src/components/common/Error.vue